import { render, staticRenderFns } from "./TesseractPlusIcon.vue?vue&type=template&id=6a45f346&"
import script from "./TesseractPlusIcon.vue?vue&type=script&lang=js&"
export * from "./TesseractPlusIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports